import React from 'react';

const Footer = () => {
  return(
    <div id="footer">
      <p className="stay-tuned">
        Stay tuned!
      </p>
    </div>
  );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js